import React, { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import { PDFViewer, Document, Page, View, Text, StyleSheet } from '@react-18-pdf/renderer';
import { Header, Footer } from '../../_reports';
import { STATUS_ORCAMENTO } from '../../utils'
import {
  relatorioAction
} from '../../_actions'
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import moment from 'moment'

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    fontSize: 7,
    fontFamily: 'Roboto-Regular',
    borderTop: 1,
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1
  },
  header: {
    padding: 5,
    fontFamily: 'Roboto-Bold',
    textAlign: 'left'
  },
  headerValor: {
    padding: 5,
    fontFamily: 'Roboto-Bold',
    textAlign: 'left'
  },
  headerAgrupamento: {
    padding: 4,
    fontFamily: 'Roboto-Bold',
    textAlign: 'center'
  },
  total: {
    padding: 4,
    fontFamily: 'Roboto-Bold',
    textAlign: 'right'
  },
  cell: {
    padding: 3,
    textAlign: 'left'
  },
  cellDatas: {
    padding: 3,
    fontSize: 10,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    fontFamily: 'Roboto-Bold'
  }
});

const CustomPage = styled(Page)(() => ({
  padding: 20,
  paddingBottom: 25,
  height: '100%',
  width: '100%'
}));

const RelatorioOrcamentoOrdemServicoPrint = (props) => {

  const dispatch = useDispatch()
  const [ready, setReady] = React.useState(false);
  const { relatorio } = props.relatorio
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {

  }, [props.relatorio]);

  const filterModel = {
    IdEmpresa: queryParams.get('IdEmpresa') ?? 0,
    DataInicio: queryParams.get('DataInicio'),
    DataFim: queryParams.get('DataFim')
  };

  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 1100);
  }, [])

  const onRendered = () => {
  };

  return (
    (ready &&
      <div style={{ width: '100%', height: '100%' }}>
        <PDFViewer style={{ width: "100%", height: "100vh" }}>
          <Document onRender={onRendered} width='100%'>
            <CustomPage orientation="landscape" size="A4" style={styles.page} wrap={true} >
              <Header
                title='Relatório de Orçamentos Enviados'
                info={<Text>ROTOR - FABRICAÇÃO, MANUTENÇÃO, REPARAÇÃO E FORNECIMENTO LTDA - 40.691.238/0001-25</Text>}
              />
              <View style={{ marginBottom: 5, marginTop: 60 }}>
                <View style={[styles.row]} wrap={false}>
                  <View style={[styles.header, { width: 60 }]}>
                    <Text>DATA</Text>
                  </View>
                  <View style={[styles.header, { width: 350 }]}>
                    <Text>ORDEM DE SERVIÇO</Text>
                  </View>
                  <View style={[styles.header, { width: 110 }]}>
                    <Text>EMPRESA</Text>
                  </View>
                  <View style={[styles.header, { width: 150 }]}>
                    <Text>VALOR</Text>
                  </View>
                  <View style={[styles.headerValor, { width: 90 }]}>
                    <Text>STATUS</Text>
                  </View>
                </View>
                {relatorio && relatorio.length > 0 ?
                  relatorio.map((n) => (
                    <View style={[styles.row]} key={n.id} wrap={false}>
                      <View style={[styles.cell, { width: 60 }]}>
                        <Text>{n.data ? moment(n.data).format('DD/MM/yyyy') : '-'}</Text>
                      </View>
                      <View style={[styles.cell, { width: 350, display: 'flex', flexDirection: 'column' }]}>
                        <Text>{n.tituloOrdemServico?.toUpperCase()}</Text>
                      </View>
                      <View style={[styles.cell, { width: 110 }]}>
                        <Text>{n.empresa ? n.empresa.toUpperCase() : '-'}</Text>
                      </View>
                      <View style={[styles.cell, { width: 150 }]}>
                        <Text>{n.valor ? 'R$' + n.valor.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '-'}</Text>
                      </View>
                      <View style={[styles.headerValor, { width: 90 }]}>
                        <Text>{n.statusOrcamento == STATUS_ORCAMENTO.APROVADO ? 'APROVADO' : n.statusOrcamento == STATUS_ORCAMENTO.REPROVADO ? 'REPROVADO' : 'PENDENTE'}</Text>
                      </View>
                    </View>
                  ))
                  : (
                    <View style={[styles.row]}>
                      <View style={[styles.cell, { width: 850 }]}>
                        <Text>Nenhum registro encontrado</Text>
                      </View>
                    </View>
                  )
                }
              </View>
            </CustomPage >
          </Document>
        </PDFViewer>
      </div >
    )
  );
}

const mapStateToProps = (state) => {
  return state;
};

const connectedRelatorioOrcamentoOrdemServicoPrintPage = withRouter(connect(mapStateToProps, null, null)(RelatorioOrcamentoOrdemServicoPrint));
export { connectedRelatorioOrcamentoOrdemServicoPrintPage as RelatorioOrcamentoOrdemServicoPrint };
